import React from 'react';
import { FaTrashAlt } from 'react-icons/fa';
import TableActionButton from '../TableActionButton/TableActionButton';

const TableActionButtonDelete = ({ title = 'Excluir', size = 10, onClick = () => {}, className }) => {
  return <TableActionButton onClick={onClick} title={title} icon={<FaTrashAlt size={size} className={className}/>} />;
};

export default TableActionButtonDelete;
